export type Dimensions = {
  width: number;
  height: number;
};

export const COMPONENT_DIMENSION_ID_PREFIX = 'component-dims-';
